//COMMUNICATION
export const COMMUNICATION = {
  communication: [18, 9, 1],
  press: [18, 9],
  paper_press: [18],
  digital_press: [9],
  notes: [1]
};

//DISTRIBUTION
export const DISTRIBUTION = {
  distribution: [14, 10, 5, 25, 3],
  synthesis: [14],
  restaurants_caves: [10],
  primeur_campaign: [5],
  online_sales: [25],
  auction_sales: [3]
};

export const PRICES = {
  prices_analysis: [32]
};

export const TRAVEL = {
  travel: [11]
};

// Carnets marché
export const CARNETS_MARCHE = {
  carnets_marche: [69]
};
export const GLOBAL_DATA_VIEW = {
  global_data_view: [70]
};

// Other channels
export const PRICES_ANALYSIS = [32];
export const AUCTION_SALES = [3];

// NEGOCIANT
export const NEGOCE = {
  audit_de_place: [68],
  negociant: [34]
};
